import { styled, TextField } from '@mui/material';

export const StyledBox = styled('div')`
  width: 100%;
`;

export const StyledTextField = styled(TextField)`
  align-self: flex-start;
`;
